export const aboutData = {
  title: "Who I am",
  description1:
    "My name's Harsh Rajpal. I'm a third year student and a developer based in India.",
  description2:
    "During the day I go to college and in the evening I  work on  utilize the time to bmy skills. I spent my leisure hours solving problems on coding platforms and writing blogs. Right now I'm also trying to develop new skills. I love to learn and explore new arenas.",
  image: 2,
};
